import ForecastsList from "@/components/forecasts/pages/ForecastsList";
import ForecastDetail from "@/components/forecasts/pages/ForecastDetail";
import ForecastWindowDetail from "@/components/forecasts/pages/ForecastWindowDetail";
import { FUNCTIONALITY } from "@/components/forecasts/constants";
import ForecastSecondaryWindow from "@/components/forecasts/pages/ForecastSecondaryWindow";
import ForecastCreate from "@/components/forecasts/pages/ForecastCreate";

export const ROUTES = Object.freeze({
    BASE: "/admin/forecasts"
});

export const router = [
    {
        path: ROUTES.BASE,
        component: ForecastsList,
        name: "ForecastsList",
        meta: {
            requiresAuth: true,
            title: "Forecasts List",
            functionality: FUNCTIONALITY
        }
    },
    {
        path: `${ROUTES.BASE}/create`,
        component: ForecastCreate,
        name: "ForecastCreate",
        meta: {
            requiresAuth: true,
            title: "Forecasts Create",
            functionality: FUNCTIONALITY
        }
    },
    {
        path: `${ROUTES.BASE}/:id`,
        component: ForecastDetail,
        name: "ForecastDetail",
        meta: {
            requiresAuth: true,
            title: "Forecasts Detail",
            functionality: FUNCTIONALITY
        }
    },
    {
        path: `${ROUTES.BASE}/window/:id`,
        component: ForecastWindowDetail,
        name: "ForecastWindowDetail",
        meta: {
            requiresAuth: true,
            title: "Forecasts Window Detail",
            functionality: FUNCTIONALITY
        }
    },
    {
        path: `${ROUTES.BASE}/:id/secondary-windows`,
        component: ForecastSecondaryWindow,
        name: "ForecastSecondaryWindow",
        meta: {
            requiresAuth: true,
            title: "Forecasts Secondary Window",
            functionality: FUNCTIONALITY
        }
    }
];



// WEBPACK FOOTER //
// ./src/components/forecasts/router.js